import styled from 'styled-components';

const WrapperZoom = styled.div`
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const ButtonZoom = styled.button`
  align-items: center;
  background-color: transparent;
  border: 0;
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  margin: 0 1rem;
  padding: 0.5rem;
`;

export { WrapperZoom, ButtonZoom };
